import {connect} from 'react-redux';
import {get} from 'lodash';
import {createStructuredSelector} from 'reselect';

import {CSBPlusReportEndDate} from '/enum/dates.enum';
import {userId} from '/redux/selector/currentUser.selector';
import {
  bonusEarnedAccelById,
  bonusEarnedClientSupportPlusById,
  bonusQualifiedForIncentiveTripById,
  coachesEarnedClientAcquisitionById,
  coachesEarnedQuickStartBonusById,
  coachesRankUpById,
} from '/redux/selector/metric.teams.selector';
import {
  variablesBonusDisplayDate,
  variablesFeatureFlag,
} from '/redux/selector/remoteConfig.selector';
import {getDateUtilDefaultInstance} from '/util/date.util';
import {withProps} from '/util/selector.util';

import CoachesToCelebrateSection from './CoachesToCelebrateSection';

const withCoachUserId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    earnedAccelBonusCount: withCoachUserId(bonusEarnedAccelById),
    clientAcquisitionBonus: withCoachUserId(coachesEarnedClientAcquisitionById),
    clientQuickStartBonus: withCoachUserId(coachesEarnedQuickStartBonusById),
    rankUp: withCoachUserId(coachesRankUpById),
    earnedClientSupportBonusPlusCount: withCoachUserId(
      bonusEarnedClientSupportPlusById,
    ),
    qualifiedIncentiveTripCount: withCoachUserId(
      bonusQualifiedForIncentiveTripById,
    ),
    featureFlag: variablesFeatureFlag,
    bonusDisplayDate: variablesBonusDisplayDate,
  }),

  _dispatch => ({}),
  (stateProps, dispatchProps, ownProps) => {
    const {bonusDisplayDate} = stateProps;

    const parsedBonusDisplayDate =
      typeof bonusDisplayDate === 'string'
        ? JSON.parse(bonusDisplayDate)
        : bonusDisplayDate || {};
    const {CSBPlusReportEndDate: remopteConfigCSBPlusReportEndDate} =
      parsedBonusDisplayDate;
    const endDate = remopteConfigCSBPlusReportEndDate || CSBPlusReportEndDate;

    /**  showCSBPlus -  check is to show CSB+ summary and report temporarily.
     if the current date falls on or before the end date, CSB+ summary tab will be visible */

    // This is in UTC time. it converts to 2024-12-31 2am ET
    const showCSBPlusBonusSummary =
      getDateUtilDefaultInstance().isDateSameOrBefore(endDate);

    const showIncentiveTrip = get(
      stateProps,
      'featureFlag.showQualifiedIncentiveTrip',
      false,
    );
    const showEarnedQSB = get(stateProps, 'featureFlag.showEarnedQSB', false);
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      showCSBPlus: showCSBPlusBonusSummary,
      showIncentiveTrip,
      showEarnedQSB,
    };
  },
)(CoachesToCelebrateSection);
